import qs, { ParsedQs } from 'qs';

export interface GetParamsResponse {
  params: ParsedQs;
}

/**
 * A useGetParams hook returns get parameters from a search string, if any.
 * Usage:
 * https://www.localhost.com/?token=123
 * const { token } = useGetParams();
 * console.log(token);
 * > 123
 */
export const useGetParams = <T = ParsedQs>(): T => {
  const getParamsString = window.location.search.substr(1);

  return qs.parse(getParamsString) as T;
};
